import React, { useState, useEffect, useRef } from "react";
import Style from "./Home.module.css";
import "./Courses.css";
import { Helmet } from "react-helmet";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import { BallTriangle } from "react-loader-spinner";
import { toast } from "react-toastify";

const Home = () => {
  const notify = (mess, type) => {
    toast[type](mess);
  };
  const navigate =useNavigate()
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [loading, setloading] = useState(false);

const [CousreChange, setCousreChange] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const handleClick = (cousreIndex) => {
    navigate(`/UpdateCourse/${cousreIndex}`)
    console.log("sss",cousreIndex);
  };
  const handelDeleteCousre = async (courseIndex) => {
    try {
      setloading(true);
      const response = await axios.delete(`https://itc-541ea27f6158.herokuapp.com/api/v1/course/${courseIndex}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`
        }
      });
      setloading(false);
      notify("تم حذف الدوره التعليمية بنجاح", "success");

      // If the delete request is successful, update the courseData state by removing the deleted course
      if (response.status === 200) {
        setCourseData(prevData => {
          return prevData.filter(course => course.courseId !== courseIndex);
        });
      }
    } 
    catch (error) {
      if (error.response.status === 405) {
        setloading(false)
         navigate('/login') ;
         notify(error.response.data.message, "success");

      }
      notify(error.response.data.message, "success");

      console.error('Error fetching profile data:', error);
    }
   
  };
  const [courseData, setCourseData] = useState(null);

  const handelUpdateStatusCousre = async (courseIndex) => {
  console.log(courseIndex);
  try {
    setloading(true);
    const response = await axios.put(`https://itc-541ea27f6158.herokuapp.com/api/v1/course/${courseIndex}/hide`, {},{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`
      }
    });
    console.log(response);
    notify("تم تعديل حاله الدوره التعليمية بنجاح", "success");
    const updatedCourseData = await axios.get(`https://itc-541ea27f6158.herokuapp.com/api/v1/course`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`
      }
    });
    // Update courseData with the updated data of the course
    setCourseData(updatedCourseData?.data?.data);
    setloading(false);

  }  catch (error) {
    if (error.response.status === 405) {
      setloading(false)
       navigate('/login') ;
       
    }
    setloading(false);
    notify(error.response.data.message, "error");


    console.error('Error fetching profile data:', error);
  }
  

  };
    useEffect(() => {
      const fetchData = async () => {
        try {
          setloading(true)
          const response = await axios.get(`https://itc-541ea27f6158.herokuapp.com/api/v1/course`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`
            }
          });
          setCourseData(response?.data.data);
          setloading(false)
        }
         catch (error) {
          if (error.response.status === 405) {
            setloading(false)
             navigate('/login') ;
          }
          setloading(false);

          console.error('Error fetching profile data:', error);
        }
      };
    
  
      fetchData();
  
    }, []);
  return (
    <>
      <Helmet>
        <title>الدورات التعليمية</title>
      </Helmet>

      {loading?<>
                <div className={`${Style.home2} w-full flex justify-center`}>
                <BallTriangle
  height={100}
  width={100}
  radius={5}
  color="#4fa94d"
  ariaLabel="ball-triangle-loading"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  />

</div>
          </>:<>
          
      <div className={`${Style.home} bg-gray-100 rounded-xl min-h-screen`}>
   
        <div className="overflow-x-auto">
          <table className="table-auto w-full">
            <thead className="Corsess-Head">
              <tr className="flex flex-row  h-15">
                <th className="max-h-14 flage flex w-16">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="18"
                    viewBox="0 0 20 24"
                    fill="none"
                  >
                    <path
                      d="M0 0L1.50842 0L1.50842 24H0L0 0ZM21 6.75L3.01683 13.4531L3.01683 0.046875L21 6.75ZM4.52525 11.2969L16.7104 6.75L4.52525 2.20313L4.52525 11.2969Z"
                      fill="#009539"
                    />
                  </svg>
                </th>
                <th className=" Address mx-3 p-3 max-h-14 basis-5/6 ">
                  <div className="flex flex-row">
                    <div className="text-right basis-1/3">عنوان الدوره التعليمية</div>
                    <div className="text-center basis-1/3 ps-10">الحالة</div>
                    <div className="text-center basis-1/3 ps-12">السعر</div>
                    <div className="text-center basis-1/3 ps-10 ">نوع الدورة</div>
                  </div>
                </th>
                <th className="flex-none max-h-14 pt-1 p-2">
                  <Link to={'/Addcourse'} type="button" className="button btn">
                    <span className="">اضافة دورة جديد</span>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="14" cy="14" r="14" fill="#FBFBFB" />
                      <path
                        d="M16 15.5H15.5V16V22.5C15.5 22.7652 15.3946 23.0196 15.2071 23.2071C15.0196 23.3946 14.7652 23.5 14.5 23.5C14.2348 23.5 13.9804 23.3946 13.7929 23.2071C13.6054 23.0196 13.5 22.7652 13.5 22.5V16V15.5H13H6.5C6.23478 15.5 5.98043 15.3946 5.79289 15.2071C5.60536 15.0196 5.5 14.7652 5.5 14.5C5.5 14.2348 5.60536 13.9804 5.79289 13.7929C5.98043 13.6054 6.23478 13.5 6.5 13.5H13H13.5V13V6.5C13.5 6.23478 13.6054 5.98043 13.7929 5.79289C13.9804 5.60536 14.2348 5.5 14.5 5.5C14.7652 5.5 15.0196 5.60536 15.2071 5.79289C15.3946 5.98043 15.5 6.23478 15.5 6.5V13V13.5H16H22.5C22.7652 13.5 23.0196 13.6054 23.2071 13.7929C23.3946 13.9804 23.5 14.2348 23.5 14.5C23.5 14.7652 23.3946 15.0196 23.2071 15.2071C23.0196 15.3946 22.7652 15.5 22.5 15.5H16Z"
                        fill="#009539"
                        stroke="#009539"
                      />
                    </svg>
                  </Link>
                </th>
              </tr>
            </thead>
            <span className={Style.brmedium}></span>
            <span className={Style.brmedium}></span>

            <tbody className="">
              
              {courseData?.map((course , cousreIndex)=>{
                return <>
                 {[cousreIndex+1].map((index) => (
                <React.Fragment key={index}>
                  <span className={Style.brmedium}></span>


                  <tr className="flex flex-row h-15 ">

                    <th
                      className={`max-h-14 flex w-16 ${
                        course?.isFree ? "special-flage" : "flage"
                                            }`}
                    >
                                        <Link to={`/${course?.courseId}/subjects`}  onClick={() => handleClick(course?.courseId)}>

                      {index}
                      </Link>
                    </th>
                    <th
                      className={`ms-3 p-3 max-h-14 basis-5/6 ${
                        course?.isFree                           ? "special-row"
                          : "bodyCorsess"
                      }`}
                    >
                      <div className="flex flex-row">
                        <div className="text-right basis-1/3 ">
                        <Link
  to={`/${course?.courseId}/subjects`}
  onClick={() => handleClick(course?.courseId)}
  title={course?.courseTitle}
>
  {course?.courseTitle.length > 80 ? `${course?.courseTitle.slice(0, 80)}...` : course?.courseTitle}
</Link>
</div>
                        <div onClick={() => {
        document.getElementById('my_modal_3').showModal();
        setCousreChange(course?.courseId);
    }}  className="cursor-pointer flex paymentOrFree basis-1/3">
                          
                          {course?.isHidden  ? (
                            <>
                            
                                        <svg  width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.95 0.95C24.35 0.35 23.3 0.35 22.55 0.95L18.95 4.55C17.3656 3.96185 15.69 3.6572 14 3.65C8.3 3.8 3.2 6.8 0.5 11.75C0.8 12.35 1.25 12.95 1.7 13.55C2.9 15.2 4.4 16.55 6.05 17.6L3.5 20.15C2.9 20.75 2.75 21.8 3.5 22.55C4.1 23.15 5.15 23.3 5.9 22.55L24.95 3.35C25.55 2.6 25.55 1.55 24.95 0.95ZM9.05 14.45L7.1 16.4C5.3 15.35 3.65 13.85 2.45 12.05C4.25 9.5 6.65 7.7 9.5 6.8C7.55 8.9 7.4 12.2 9.05 14.45ZM14.15 9.5C13.4 8.75 13.55 7.55 14.3 6.8C15.05 6.2 16.1 6.2 16.85 6.8L14.15 9.5ZM26.45 10.25C25.7 9.2 24.8 8.15 23.75 7.4L22.25 8.9C23.45 9.8 24.5 10.85 25.4 12.2C22.85 16.1 18.5 18.5 13.85 18.5H12.65L11.15 20C12.2 19.85 13.1 20 14 20C18.95 20 23.6 17.6 26.45 13.55C26.9 12.95 27.2 12.35 27.65 11.75C27.2 11.3 26.9 10.7 26.45 10.25ZM20 11L14 17C17.3 17 20 14.3 20 11Z" fill="#4D4C4C"/>
</svg>


                            </>
                          ) : (
                            <>
                            {course.isFree?<>
                              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0014 7.10303C9.20906 7.10303 3.79522 9.98072 0.542523 14.7842C0.399091 14.9968 0.29926 15.2357 0.248815 15.4871C0.198369 15.7385 0.198311 15.9975 0.248644 16.2489C0.298976 16.5003 0.398699 16.7393 0.542035 16.9519C0.685372 17.1646 0.869474 17.3467 1.08368 17.4876C1.4206 17.7184 1.78522 17.8488 2.16483 17.8488C2.79483 17.8488 3.44329 17.543 3.82406 16.9834C3.94406 16.8046 4.09175 16.6488 4.21983 16.478C4.9931 18.7217 6.44775 20.6678 8.38066 22.0447C10.3136 23.4215 12.6282 24.1604 15.0014 24.158C17.3746 24.1606 19.6893 23.4218 21.6222 22.0449C23.5552 20.668 25.0098 18.7218 25.7829 16.478C25.9098 16.65 26.0587 16.8046 26.1787 16.9834C26.7844 17.8811 28.0191 18.0946 28.9191 17.4876C29.1334 17.3466 29.3176 17.1645 29.4611 16.9518C29.6046 16.7391 29.7044 16.5001 29.7548 16.2485C29.8053 15.997 29.8053 15.7379 29.7549 15.4864C29.7046 15.2348 29.6048 14.9958 29.4614 14.783C27.8625 12.4185 25.7083 10.4821 23.1874 9.14337C20.6664 7.80466 17.8557 7.10333 15.0014 7.10303ZM15.0014 11.2857C15.9857 11.2882 16.929 11.6803 17.625 12.3763C18.3211 13.0723 18.7132 14.0156 18.7156 15C18.7132 15.9843 18.3211 16.9276 17.625 17.6236C16.929 18.3196 15.9857 18.7117 15.0014 18.7142C14.017 18.7117 13.0737 18.3196 12.3777 17.6236C11.6817 16.9276 11.2896 15.9843 11.2871 15C11.2896 14.0156 11.6817 13.0723 12.3777 12.3763C13.0737 11.6803 14.017 11.2882 15.0014 11.2857ZM19.581 11.8269C21.5079 12.5192 23.2237 13.6603 24.6648 15.1442C23.5883 19.4803 19.6664 22.7169 15.0014 22.7169C10.3364 22.7169 6.41445 19.4803 5.33791 15.1442C6.76214 13.6794 8.50049 12.5574 10.4218 11.8626C9.85064 12.6966 9.518 13.6705 9.45968 14.6796C9.40136 15.6886 9.61959 16.6945 10.0908 17.5886C10.5621 18.4828 11.2684 19.2314 12.1338 19.7536C12.9991 20.2759 13.9906 20.552 15.0014 20.5523C15.7306 20.5524 16.4527 20.4089 17.1265 20.1299C17.8003 19.851 18.4125 19.442 18.9282 18.9264C19.4439 18.4108 19.853 17.7987 20.1321 17.125C20.4112 16.4513 20.5548 15.7292 20.5548 15C20.5632 13.8674 20.2232 12.7597 19.581 11.8269Z" fill="#FBFBFB"/>
</svg>
</>:<>
<svg className="" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0014 7.10303C9.20906 7.10303 3.79522 9.98072 0.542523 14.7842C0.399091 14.9968 0.29926 15.2357 0.248815 15.4871C0.198369 15.7385 0.198311 15.9975 0.248644 16.2489C0.298976 16.5003 0.398699 16.7393 0.542035 16.9519C0.685372 17.1646 0.869474 17.3467 1.08368 17.4876C1.4206 17.7184 1.78522 17.8488 2.16483 17.8488C2.79483 17.8488 3.44329 17.543 3.82406 16.9834C3.94406 16.8046 4.09175 16.6488 4.21983 16.478C4.9931 18.7217 6.44775 20.6678 8.38066 22.0447C10.3136 23.4215 12.6282 24.1604 15.0014 24.158C17.3746 24.1606 19.6893 23.4218 21.6222 22.0449C23.5552 20.668 25.0098 18.7218 25.7829 16.478C25.9098 16.65 26.0587 16.8046 26.1787 16.9834C26.7844 17.8811 28.0191 18.0946 28.9191 17.4876C29.1334 17.3466 29.3176 17.1645 29.4611 16.9518C29.6046 16.7391 29.7044 16.5001 29.7548 16.2485C29.8053 15.997 29.8053 15.7379 29.7549 15.4864C29.7046 15.2348 29.6048 14.9958 29.4614 14.783C27.8625 12.4185 25.7083 10.4821 23.1874 9.14337C20.6664 7.80466 17.8557 7.10333 15.0014 7.10303ZM15.0014 11.2857C15.9857 11.2882 16.929 11.6803 17.625 12.3763C18.3211 13.0723 18.7132 14.0156 18.7156 15C18.7132 15.9843 18.3211 16.9276 17.625 17.6236C16.929 18.3196 15.9857 18.7117 15.0014 18.7142C14.017 18.7117 13.0737 18.3196 12.3777 17.6236C11.6817 16.9276 11.2896 15.9843 11.2871 15C11.2896 14.0156 11.6817 13.0723 12.3777 12.3763C13.0737 11.6803 14.017 11.2882 15.0014 11.2857ZM19.581 11.8269C21.5079 12.5192 23.2237 13.6603 24.6648 15.1442C23.5883 19.4803 19.6664 22.7169 15.0014 22.7169C10.3364 22.7169 6.41445 19.4803 5.33791 15.1442C6.76214 13.6794 8.50049 12.5574 10.4218 11.8626C9.85064 12.6966 9.518 13.6705 9.45968 14.6796C9.40136 15.6886 9.61959 16.6945 10.0908 17.5886C10.5621 18.4828 11.2684 19.2314 12.1338 19.7536C12.9991 20.2759 13.9906 20.552 15.0014 20.5523C15.7306 20.5524 16.4527 20.4089 17.1265 20.1299C17.8003 19.851 18.4125 19.442 18.9282 18.9264C19.4439 18.4108 19.853 17.7987 20.1321 17.125C20.4112 16.4513 20.5548 15.7292 20.5548 15C20.5632 13.8674 20.2232 12.7597 19.581 11.8269Z" fill="#009539"/>
</svg>
                            </>}
                       
      

                            </>
                          )}
                                          <dialog id="my_modal_3" className="modal">
  <div className="modal-box">
    <h3 className="font-bold text-lg mb-4 text-center text-customGreen">هل انت متأكد من تغيير حالة الدوره التعليمية ؟</h3>
 
  <div className="modal-action">
      <form method="dialog" className='mx-auto'>
        {/* if there is a button in form, it will close the modal */}
               <button onClick={() => handelUpdateStatusCousre(CousreChange)} class="py-2.5 px-5  text-sm font-medium text-white  bg-customGreen rounded-lg border border-gray-200   ">
                   تأكيد 
                    </button>
                <button class="text-white ms-3 bg-red-600 hover:bg-red-800  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                    الغاء 
                </button>
              
              </form>
    </div>
    </div>

</dialog>
                        </div>
                        <div className="text-center basis-1/3 ">
                        <Link
  
>
  {course?.coursePrice}
</Link>
</div>
                        <div className="flex paymentOrFree basis-1/3">
                          
                          {course?.isFree  ? (
                            <>
                              <p>مجانا</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon-free"
                                width="25"
                                height="25"
                                viewBox="0 0 30 30"
                              >
                                <g clipPath="url(#clip0_265_562)">
                                  <path
                                    d="M29.0625 24.375C29.0625 26.9531 26.9531 29.0625 24.375 29.0625H5.625C3.04688 29.0625 0.9375 26.9531 0.9375 24.375V5.625C0.9375 3.04688 3.04688 0.9375 5.625 0.9375H24.375C26.9531 0.9375 29.0625 3.04688 29.0625 5.625V24.375Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M15.9375 19.2188H19.6875V17.8125H17.2969V15.7031H19.6875V14.2969H17.2969V12.1875H19.6875V10.7812H15.9375V19.2188ZM25.3125 12.1875V10.7812H21.5625V19.2188H25.3125V17.8125H22.9219V15.7031H25.3125V14.2969H22.9219V12.1875H25.3125ZM11.2031 19.2188V15.7031H11.7188L12.8906 19.2188H14.2969L13.0781 15.5156C13.9219 15.1406 14.5312 14.25 14.5312 13.2188C14.5312 11.8594 13.5 10.7812 12.1875 10.7812H9.84375V19.2188H11.2031ZM11.2031 12.1875H12.1875C12.75 12.1875 13.1719 12.6563 13.1719 13.2188C13.1719 13.7813 12.7031 14.25 12.1875 14.25H11.2031V12.1875ZM6.04687 19.2188V15.7031H8.4375V14.2969H6.04687V12.1875H8.4375V10.7812H4.6875V19.2188H6.04687Z"
                                    fill="#009539"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_265_562">
                                    <rect width="30" height="30" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </>
                          ) : (
                            <>
                              <p>مدفوع</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="iconDolar"
                                width="20"
                                height="20"
                                viewBox="0 0 320 512"
                              >
                                <path
                                  d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
                                  fill="#ffff"
                                />
                              </svg>
                            </>
                          )}
                        </div>
                    
                      </div>
                    </th>
                    
                    <th
                      className={` basis- max-h-14 flex-auto text-left p-3 ${
                        course?.isFree 
                                                  ? "special-rowIcon"
                          : "iconCorsess"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => toggleMenu(index)}
                        width="20"
                        height="20"
                        className="iconDots"
                        viewBox="0 0 128 512"
                      >
                        <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
                      </svg>

                      {openMenuIndex === index && (
                        <div
                          className="dropdown-menu z-10 EditAndDelet"
                          ref={dropdownRef}
                        >
                          <div className="dropdown-item edit" onClick={() => handleClick(course?.courseId)}>
                       

                            <p>تعديل</p>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={20}
                              height={20}
                              className="icon-free"
                              viewBox="0 0 512 512"
                            >                            <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" fill="black"/></svg>




                          </div>
                          <div onClick={()=>document.getElementById('my_modal_2').showModal()} className="dropdown-item delete" >
                            <p>حذف</p>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={20}
                              height={20}
                              className="icon-free"
                              viewBox="0 0 448 512"
                            >
                              <path
                                d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                                fill="red"
                              />
                            </svg>
                          </div>
                          <dialog id="my_modal_2" className="modal">
  <div className="modal-box">
    <h3 className="font-bold text-lg mb-4 text-center text-customGreen">هل انت متأكد من حذف الدوره التعليمية ؟</h3>
 
  <div className="modal-action">
      <form method="dialog" className='mx-auto'>
        {/* if there is a button in form, it will close the modal */}
               <button onClick={() => handelDeleteCousre(course?.courseId)} class="py-2.5 px-5  text-sm font-medium text-white  bg-customGreen rounded-lg border border-gray-200   ">
                   تأكيد 
                    </button>
                <button class="text-white ms-3 bg-red-600 hover:bg-red-800  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                    الغاء 
                </button>
              
              </form>
    </div>
    </div>

</dialog>
                        </div>
                      )}
                    </th>
                  </tr>

                  <span className={Style.brmedium}></span>
                </React.Fragment>
              ))}
                
                </>
              })}
             
            </tbody>
            <div className="space"></div>
          </table>
        </div>
      </div>
          </>}

    </>
  );
};

export default Home;
